import { useCallback } from "react";
import { queryClient } from "@/client";
import { constants } from "@/constants";
import { routes } from "@/router";
import { Trans, useTranslation } from "react-i18next";
import { HiOutlineX } from "react-icons/hi";
import { HiOutlineArrowRight } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";

import { orgaInfoQueryKey } from "@/hooks/api/organisation/useGetOrgaInfo";
import Button from "@/components/atoms/Button";
import FeaturedText from "@/components/molecules/FeaturedText";

const SubscriptionError = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const confirm = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: orgaInfoQueryKey });
    navigate(routes.plans);
  }, [navigate]);

  return (
    <FeaturedText
      featuredIcon={{ icon: HiOutlineX, color: "error", size: "xl" }}
      heading={t("settings.plans.update.error.heading")}
      body={
        <Trans
          i18nKey="settings.plans.update.error.description"
          values={{ mail: constants.supportMail }}
          components={{ a: <a href={"mailto:" + constants.supportMail} className={"text-link underline"} /> }}
        />
      }
    >
      <div className={"pt-3"}>
        <Button
          label={t("settings.plans.update.error.button")}
          onClick={() => confirm()}
          trailingIcon={<HiOutlineArrowRight className={"size-5"} />}
        />
      </div>
    </FeaturedText>
  );
};

export default SubscriptionError;
